export const getDefaultError = (err, defaultErr = 'An unknown error occured') => !err ? defaultErr
	: err?.data?.message || err?.message || err?.error || defaultErr;
